module.exports = __webpack_public_path__ + "static/media/pragmaticmotobajajm.41585954.webp";